import { InjectionToken } from '@angular/core'

import { CloudWatchLogTransportConfig } from './cloud-watch-log-transport-config.type'

export const CLOUD_WATCH_LOG_TRANSPORT_CONFIG = new InjectionToken<CloudWatchLogTransportConfig>(
  ngDevMode ? 'CLOUD_WATCH_LOG_TRANSPORT_CONFIG' : '',
)
